import React, { useState } from "react";
import bg from "../images/mac-background.jpg";
import logo from "../images/logo.png";
import "./HomePage.css";
import { format } from "date-fns";
import { Tooltip } from "@mui/material";
import AboutMe from '../details/AboutMe.jsx';
import Projects from '../details/Projects.jsx';
import Achievements from '../details/Achievements.jsx';
import OpenSource from '../details/OpenSource.jsx';
import Education from '../details/Education.jsx';
import Settings from '../details/Settings.jsx';
import Internship from '../details/Internship.jsx';

function importAll(r) {
  let images = {};
  // eslint-disable-next-line
  r.keys().map((item) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
}

const images = importAll(
  require.context("../images/icons", false, /\.(png|jpe?g)$/)
);
function date() {
  let dateTime = format(new Date(), "MMMM d h:mm a");
  return dateTime;
}
function HomePage() {
  const [isAboutWindowOpen, setIsAboutWindowOpen] = useState(false);
  const [isProjectWindowOpen, setIsProjectWindowOpen] = useState(false);
  const [isEducationWindowOpen, setIsEducationWindowOpen] = useState(false);
  const [isOpenSourceWindowOpen, setIsOpenSourceWindowOpen] = useState(false);
  const [isAchievementWindowOpen, setIsAchievementWindowOpen] = useState(false);
  const [isSettingsWindowOpen, setIsSettingsWindowOpen] = useState(false);
  const [isInternshipWindowOpen, setIsInternshipWindowOpen] = useState(false);
  
  // To Handle About Window
  const handleOpenAboutWindow = () => {
    setIsAboutWindowOpen(true);
  };

  const handleCloseAboutWindow = () => {
    setIsAboutWindowOpen(false);
  };
  // To Handle Project Window
  const handleOpenProjectWindow = () => {
    setIsProjectWindowOpen(true);
  };

  const handleCloseProjectWindow = () => {
    setIsProjectWindowOpen(false);
  };
  // To Handle Education Window
  const handleOpenEducationWindow = () => {
    setIsEducationWindowOpen(true);
  };

  const handleCloseEducationWindow = () => {
    setIsEducationWindowOpen(false);
  };
  // To Handle Open Source Window
  const handleOpenOpenSourceWindow = () => {
    setIsOpenSourceWindowOpen(true);
  };

  const handleCloseOpenSourceWindow = () => {
    setIsOpenSourceWindowOpen(false);
  };
  // To Handle Achievements Window
  const handleOpenAchievementWindow = () => {
    setIsAchievementWindowOpen(true);
  };

  const handleCloseAchievementWindow = () => {
    setIsAchievementWindowOpen(false);
  };
  // To Handle Settings Window
  const handleOpenSettingsWindow = () => {
    setIsSettingsWindowOpen(true);
  };

  const handleCloseSettingsWindow = () => {
    setIsSettingsWindowOpen(false);
  };
  // To Handle Internship Window
  const handleOpenInternshipWindow = () => {
    setIsInternshipWindowOpen(true);
  };

  const handleCloseInternshipWindow = () => {
    setIsInternshipWindowOpen(false);
  };
  return (
    <div >
      <img src={bg} alt="" className="bg" />

      <div className="header">
        <img src={logo} alt="" className="logo" />
        <a href="#">
          <bold>Finder</bold>
        </a>
        <a href="#">File</a>
        <a href="#">Edit</a>
        <a href="#">View</a>

        <a className="date">{date()}</a>
      </div>

      {/* Footer */}
      <nav class="navbar">
      
          <Tooltip title="About Me">
            <button type="button" className="navbar__link" onClick={handleOpenAboutWindow}>
              <img
                className="navbar__link__image"
                src={images["app-store.png"]}
                alt="icon"
                width="40"
                height="40"
              />
            </button>
            </Tooltip>
        

       
            <Tooltip title="Projects">
              <button type="button" className="navbar__link" onClick={handleOpenProjectWindow}>
                <img
                  className="navbar__link__image"
                  src={images["pages.png"]}
                  alt="icon"
                  width="40"
                  height="40"
                />
              </button>
            </Tooltip>

        <Tooltip title="Education">
          <button type="button" className="navbar__link" onClick={handleOpenEducationWindow}>
            <img
              className="navbar__link__image"
              src={images["photos.png"]}
              alt="icon"
              width="40"
              height="40"
            />
          </button>
        </Tooltip>
        {/* <Tooltip title="Open Source Contributions">
          <button type="button" className="navbar__link" onClick={handleOpenOpenSourceWindow}>
            <img
              className="navbar__link__image"
              src={images["reminder.png"]}
              alt="icon"
              width="40"
              height="40"
            />
          </button>
        </Tooltip> */}
        <Tooltip title="Achievements">
          <button type="button" className="navbar__link" onClick={handleOpenAchievementWindow}>
            <img
              className="navbar__link__image"
              src={images["safari.png"]}
              alt="icon"
              width="40"
              height="40"
            />
          </button>
        </Tooltip>
        <Tooltip title="Settings">
          <button type="button" className="navbar__link" onClick={handleOpenSettingsWindow}>
            <img
              className="navbar__link__image"
              src={images["settings.png"]}
              alt="icon"
              width="40"
              height="40"
            />
          </button>
        </Tooltip>
        <Tooltip title="Internships">
          <button type="button" className="navbar__link" onClick={handleOpenInternshipWindow}>
            <img
              className="navbar__link__image"
              src={images["ui.png"]}
              alt="icon"
              width="40"
              height="40"
            />
          </button>
        </Tooltip>
        <Tooltip title="Music">
          <button type="button" className="navbar__link">
            <img
              className="navbar__link__image"
              src={images["music.png"]}
              alt="icon"
              width="40"
              height="40"
            />
          </button>
        </Tooltip>
      </nav>
      {isAboutWindowOpen && <AboutMe onClose={handleCloseAboutWindow} />}
      {isProjectWindowOpen && <Projects onClose={handleCloseProjectWindow} />}
      {isEducationWindowOpen && <Education onClose={handleCloseEducationWindow} />}
      {/* {isOpenSourceWindowOpen && <OpenSource onClose={handleCloseOpenSourceWindow} />} */}
      {isAchievementWindowOpen && <Achievements onClose={handleCloseAchievementWindow} />}
      {isSettingsWindowOpen && <Settings onClose={handleCloseSettingsWindow} />}
      {isInternshipWindowOpen && <Internship onClose={handleCloseInternshipWindow} />}

    </div>
  );
}

export default HomePage;
